// action types constants.
export const SET_MY_VERITAS_DATA = "SET_MY_VERITAS_DATA";
